ike-order-cashless{
  .select-ticket, .iframe-loader{
    text-align: center;
    padding: 40px;
  }
  .cashlessPartner{
    min-height: 600px;
    height: 100%;
    border-radius: 10px;
  }
}
